var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkChain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.71309 11.2868C9.39572 11.9693 10.3215 12.3528 11.2868 12.3528C12.2522 12.3528 13.178 11.9693 13.8606 11.2868L16.4339 8.71345C17.1057 8.02861 17.48 7.10626 17.4754 6.14694C17.4708 5.18761 17.0877 4.2689 16.4093 3.59055C15.731 2.91219 14.8123 2.52906 13.8529 2.52446C12.8936 2.51985 11.9713 2.89414 11.2864 3.56595L9.99976 4.85261M11.2864 8.71345C10.6038 8.03114 9.67822 7.64785 8.71309 7.64785C7.74797 7.64785 6.82235 8.03114 6.13976 8.71345L3.56559 11.2868C2.88299 11.9694 2.49951 12.8952 2.49951 13.8605C2.49951 14.8259 2.88299 15.7517 3.56559 16.4343C4.24819 17.1169 5.174 17.5004 6.13934 17.5004C7.10469 17.5004 8.03049 17.1169 8.71309 16.4343L9.99976 15.1476L11.2864 8.71345Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkChain);
export default __webpack_public_path__ + "static/media/link-chain.5592f54ca43de42db52d456731c6636f.svg";
export { ForwardRef as ReactComponent };